"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._curry = void 0;
function _curry(fn) {
    return (arg1) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return (...rest) => fn(arg1, ...rest);
    };
}
exports._curry = _curry;
